<template>
    <v-form
        ref="form"
        :model="input"
        :action="endpoint"
        :method="method"
    >
        <template scope="{ error, errorState }">
            <b-tabs>
                <b-tab title="Campus"
                       active>

                  <v-input-field
                      label="Name"
                      v-model="input.name"
                      :error="error('name')"
                      placeholder="Enter Campus Name"
                      :state="errorState('name')"
                  />

                    <select-field
                        label="Venue Type"
                        description="Does the campus have a weekly live speaker, or is it a video venue?"
                        v-model="input.video_venue"
                        :error="error('video_venue')"
                        :options="videoVideoOptions"
                        :state="errorState('video_venue')"
                        placeholder="Enter Title"/>

                    <speakers-field
                        label="Default Speaker"
                        :error="error('default_speaker')"
                        :state="errorState('default_speaker')"
                        description="New messages for this campus will have this speaker selected by default."
                        v-model="input.default_speaker"
                    />
                </b-tab>
            </b-tabs>
        </template>
    </v-form>
</template>

<script>
    import SelectField from "../Fields/SelectField"
    import SpeakersField from '../Fields/SpeakersField'

    export default {
        components: {SpeakersField, SelectField},
        props: ["campus"],
        data()
        {
            return {
                input: {
                    video_venue: false,
                    default_speaker: null
                },
                videoVideoOptions: [
                    {
                        text: 'The Campus is a Video Venue.',
                        value: 1
                    },
                    {
                        text: 'The campus has a weekly live speaker.',
                        value: 0
                    }
                ],
                error: ""
            }
        },
        computed: {
            endpoint()
            {
                return "/campuses/" + this.campus.id
            },
            method()
            {
                return "PUT"
            }
        },
        created()
        {
            this.input.video_venue = this.campus.video_venue ? 1 : 0
            this.input.default_speaker = this.campus.default_speaker
            this.input.name = this.campus.name
        }
    }

</script>
